import { SceneObjectType } from "~/types/SceneObjectType";
import { ISpawnPointSceneObject } from "~/types/ISpawnPointSceneObject";
import { generateGroupEntity } from "../groupEntity";

export const generateSpawnPointEntity = (parentId?: string): Omit<ISpawnPointSceneObject, "order"> => {
  return generateGroupEntity(parentId, SceneObjectType.SPAWN_POINT, "Spawn Point");
};
